import GoalActivitiesSection from '@/components/goals/GoalActivitiesSection';
import { PlentyGoalAccountFinancialEntity } from '@common/financialEntities';
import { Goal } from '@common/goals';
import { EntityViewGrid } from '../common/EntityView';
import ErrorBoundary from '../common/ErrorBoundary';
import GoalDetailInvestmentInfoSection from './GoalDetailInvestmentInfoSection';

interface GoalDetailLowerContentTheirsProps {
    goal: Goal;
    partnerGoalAccount: PlentyGoalAccountFinancialEntity;
    filterActivitiesByGoalAccountId?: string;
}

const GoalDetailLowerContentTheirs = ({
    goal,
    partnerGoalAccount,
    filterActivitiesByGoalAccountId,
}: GoalDetailLowerContentTheirsProps) => {
    return (
        <>
            <EntityViewGrid
                left={
                    <>
                        <ErrorBoundary>
                            <GoalDetailInvestmentInfoSection
                                goalAccount={partnerGoalAccount}
                            />
                        </ErrorBoundary>
                    </>
                }
                right={
                    <GoalActivitiesSection
                        goal={goal}
                        filterByGoalAccountId={filterActivitiesByGoalAccountId}
                    />
                }
            />
        </>
    );
};

export default GoalDetailLowerContentTheirs;
